module.exports = __webpack_public_path__ + "img/aleshina.db26664f.jpg";